import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetHistoryMonitoringColumns } from './useGetHistoryMonitoring';
import FilterTrapHistoryDataTable from './HistoryTable/FilterTrapHistoryDataTable';

import useScreenSize from 'hooks/Screen/useScreenSize';
import { TrapActivationHistoryMonitoring } from 'api/traps/types';
import { useDateRange } from 'components/FilterDataTable/CustomExpander/useDateRange';
import TrapMonitoringHistoryExpandable from 'components/TrapsTables/MultiCatchMouseTraps/TrapMonitoringHistoryExpandable';

interface TrapHourlyHistoryCardProps {
  slug: string;
  type: string;
}

const TrapHourlyHistoryCard: React.FC<TrapHourlyHistoryCardProps> = ({ slug, type }) => {
  const { t } = useTranslation();
  const searchFields = ['msg_token', 'order_datetime'];
  const { startDate, endDate, isLoading, data, setStartDate, setEndDate, refetch } = useDateRange({
    slug,
    type,
  });
  const [page, setPage] = useState(1);
  const [ordering, setQueryParam] = useState('');
  const [search, setSearch] = useState('');

  const { isNotDesktop } = useScreenSize();
  const columns = useGetHistoryMonitoringColumns({ type });

  useEffect(() => {
    refetch();
  }, [page, search, ordering, refetch, startDate, endDate]);

  return (
    <div className="row">
      <div className="col-12">
        <div className="card shadow-lg">
          <div className="card-header">
            <div className="d-flex align-items-center">
              <div className="m-1">
                <input
                  type="date"
                  className="form-control"
                  value={startDate}
                  onChange={e => setStartDate(e.target.value)}
                />
              </div>
              <div className="m-1">
                <input
                  type="date"
                  className="form-control"
                  value={endDate}
                  onChange={e => setEndDate(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="card-body" style={{ minHeight: '520px' }}>
            <FilterTrapHistoryDataTable<TrapActivationHistoryMonitoring>
              title={t('MCTDetail.TrapMonitoringHistoryCard.tableTitle')}
              titlePerPage={t('MCTDetail.TrapHistoryCard.titlePerPage')}
              columns={columns}
              data={data || []}
              onChangePage={setPage}
              onChangeFilterParams={setQueryParam}
              onChangeSearch={setSearch}
              searchFields={searchFields}
              isLoading={isLoading}
              expandableRows={isNotDesktop}
              expandableRowsComponent={row => <TrapMonitoringHistoryExpandable data={row.data} />}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrapHourlyHistoryCard;
